'use strict';
const $galleryItems = $('.swiper-slide.product-slide');
const $fullscreenCloseButton = $('.product-fullscreen-close-button');
let thumbCarousel;

/**
 * Open fullscreen images for Desktop
 * @returns {void}
 */
function openFullscreenImage() {
  const $overlayActive = $('.product-fullscreen-images-overlay');
  const $fullscreenImageWrapper = $('.product-fullscreen-images-wrapper');
  const $productWrapper = $('.product-wrapper');
  const $fullscreenImage = $('.product-fullscreen-image');
  const $ContainerImageZoom = $fullscreenImage.closest('.product-fullscreen-images[data-image-index]');

  const $slidesMobile = $('.swiper.product-carousel-main.d-md-none .swiper-slide.product-slide');
  let currentIndex = 0

  const zoomableIndexes = $slidesMobile
      .map((i, el) => $(el).find('[data-zoom-img]').length ? parseInt($(el).attr('data-index')) : null)
      .get(); // array di data-index zoomabili


  $('body').on('click', '.swiper:not(.thumbnails) .swiper-slide.product-slide:not(.js-editorial-has-editorial)', function () {
    currentIndex = parseInt($(this).attr('data-index'));
    const imgSource = $(this).find('.js-product-image').attr('data-zoom-img');
    $fullscreenImage.attr('src', imgSource);
    $ContainerImageZoom.attr('data-image-index', currentIndex);

    updateArrows(currentIndex, $slidesMobile, zoomableIndexes);

    // let selected;
    // for (let i = 0; i < $fullscreenImage.length; ++i) {
    //   imgSourceFullscreen = $fullscreenImage[i].dataset.fullSrc;
    //   if (imgSource && imgSource.indexOf(imgSourceFullscreen) !== -1) {
    //     selected = $fullscreenImage[i];
    //   }
    //   $fullscreenImage[i].setAttribute('src', $fullscreenImage[i].dataset.fullSrc);
    //   $fullscreenImage[i].style.display = 'block';
    // }

    $productWrapper.addClass('fullscreen');
    $overlayActive.addClass('active');
    $('html, body').addClass('product-main-overlay');
    $fullscreenCloseButton.focus();

  });

  $('body').on('click', '.swiper.thumbnails .product-slide', function (e) {
    const imgSource = $(this).find('.js-product-image').attr('data-zoom-img');
    $fullscreenImage.attr('src', imgSource);
  });

  $('body').on('click', '.product-fullscreen-close-button', function () {
    if (isMobile) {
      const $mobileCarouselEl = $('.product-carousel-main.d-md-none')[0];
      if ($mobileCarouselEl && $mobileCarouselEl.swiper) {
          const swiperInstance = $mobileCarouselEl.swiper;
          const swiperSlideIndex = swiperInstance.slides.findIndex(slide =>
              parseInt(slide.dataset.index) === parseInt(currentIndex)
          );
          if (swiperSlideIndex >= 0) {
              swiperInstance.slideTo(swiperSlideIndex, 0);
          }
        }
        $fullscreenImageWrapper.scrollTop(0);
        $productWrapper.removeClass('fullscreen');
        $overlayActive.removeClass('active');
        $('html, body').removeClass('product-main-overlay');

    } else {
        $fullscreenImageWrapper.scrollTop(0);
        $productWrapper.removeClass('fullscreen');
        $overlayActive.removeClass('active');
        $('html, body').removeClass('product-main-overlay');
        $galleryItems.get(0).focus();
    }

  });

  $('body').on('click', '.js-arrow-prev, .js-arrow-next', function () {
      const newIndex = parseInt($(this).attr('data-index'));

      const $targetSlide = $slidesMobile.filter(`[data-index="${newIndex}"]`);
      const newImg = $targetSlide.find('.js-product-image').attr('data-zoom-img');

      $fullscreenImage.attr('src', newImg);
      $ContainerImageZoom.attr('data-image-index', newIndex);

      currentIndex = newIndex;
      updateArrows(currentIndex, $slidesMobile, zoomableIndexes);
  });
}

function updateArrows(currentIndex, $allSlides, zoomableIndexes) {
    const currentPos = zoomableIndexes.indexOf(currentIndex);

    // calcola precedente e successivo nel ciclo
    const prevIndex = zoomableIndexes[(currentPos - 1 + zoomableIndexes.length) % zoomableIndexes.length];
    const nextIndex = zoomableIndexes[(currentPos + 1) % zoomableIndexes.length];

    const $prevSlide = $allSlides.filter(`[data-index="${prevIndex}"]`);
    const $nextSlide = $allSlides.filter(`[data-index="${nextIndex}"]`);

    $('.js-arrow-prev').attr({
        'data-index': prevIndex,
        'data-zoom-img': $prevSlide.find('.js-product-image').attr('data-zoom-img')
    });

    $('.js-arrow-next').attr({
        'data-index': nextIndex,
        'data-zoom-img': $nextSlide.find('.js-product-image').attr('data-zoom-img')
    });
}

function reInitCarousels(){
  thumbCarousel && thumbCarousel.destroy();
  initPDPCarousels();
}

function init(){
  initPDPCarousels();
  openFullscreenImage();
}

function initPDPCarousels() {
  thumbCarousel = new Swiper('.thumbnails', {
     direction: "vertical",
      spaceBetween: 5,
      slidesPerView: 5,
      centerMode: true,
      freeMode: true,
      watchSlidesProgress: true
  });

  const mainCarouselsArray = []

  $('.product-carousel-main').each(function() {
      try {
        let slider = new Swiper(this, {
          spaceBetween: 10,
          mousewheel: {
              forceToAxis: true
          },
          pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
          lazy: true,
          thumbs: {
              swiper: thumbCarousel
          },
          breakpoints: {
              992: {
                  spaceBetween: 120,
                  direction: 'vertical',
                  slidesPerView: 1,
                  centerMode: true,
                  autoHeight: false,
                  freeMode: {
                      enabled: false,
                      sticky: true,
                  }
              },
          },
        });

        mainCarouselsArray.push(slider);
      } catch (e){
        console.error(e)
      }
  });

  $('.thumbnails .swiper-slide').each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();
      const clickIndex = $(this).attr('data-index');
      mainCarouselsArray.forEach(function(c) {
        c.slideTo(clickIndex);
      })
    })
  })
}

module.exports = {
  init: init,
  reInitCarousels: reInitCarousels
}
